<template>
  <div class="company-card">
    <div class="card-title">{{ companyItem.topTitle }}</div>
    <div class="card-content">
      <!-- <div class="fl-img">
        <img
          v-if="companyItem.logoUrl"
          :src="companyItem.logoUrl"
          :alt="companyItem.topTitle"
        />
      </div> -->
      <div class="fr-text">
        <!-- <div class="fr-title">{{ companyItem.topTitle }}</div> -->
        <div class="fr-logo">
          <img
            v-if="companyItem.logoUrl"
            :src="companyItem.logoUrl"
            :alt="companyItem.topTitle"
          />
        </div>
        <div
          class="fr-p"
          v-for="(item, index) in companyItem.description"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    companyItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.company-card {
  width: 100%;
}
.card-title {
  width: 100%;
  margin-top: 30px;
  height: 45px;
  line-height: 45px;
  font-size: 20px;
  color: #333;
  font-weight: 700;
  padding-left: 10px;

  position: relative;
}
.card-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  bottom: 12px;
  background-color: #2d8cf0;
  width: 3px;
}
.card-content {
  display: flex;
  border: 1px solid #dbd4cd;
  padding: 0 30px 30px 0;
  box-sizing: border-box;
}
.fl-img {
  width: 300px;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fl-img img {
  width: 100%;
}
.fr-text {
  flex: 1;
  padding-left: 35px;
  box-sizing: border-box;
  padding-top: 35px;
}
.fr-logo {
  /* width: 300px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.fr-logo img {
  width: 300px;
}
.fr-title {
  padding: 20px 0px 10px 0px;
  font-size: 18px;
  border-bottom: 1px solid #f1eeeb;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.fr-p {
  text-indent: 2em;
  font-size: 14px;
  line-height: 2;
}
</style>